<template>
    <el-dialog :visible.sync="show" :close-on-click-modal="false" append-to-body width="600px" :before-close="closeDialog" title="多模式标签管理" :show-close="false">
        <el-alert
            title="最多只能添加两个标签，每个标签最多4个字符"
            type="warning"
            :closable="false"

            show-icon>
        </el-alert>
        <div style="margin-top: 20px;">
           <el-tag
                :key="tag"
                v-for="tag in dynamicTags"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)">
                {{tag}}
            </el-tag>
            <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
                :maxlength="4"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">添加标签</el-button>
        </div>
        <div class="dialog-footer">
            <el-button type="primary" @click="submitForm">确定</el-button>
            <el-button @click="closeDialog">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
let _this;

export default {
    components: {

    },
    props: {
        isShow: Boolean,
        data: {},
        search_data: {
            type: Object,
            default: () => ({
                order_mode_code: '',
            })
        }
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            console.log(_this.data);
            if (_this.search_data) {
                _this.search_data.order_mode_code = _this.data.code;
            }

            _this.searchLabelManage();
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            show: false,
            dynamicTags: [],
            inputVisible: false,
            inputValue: ''
        };
    },
    methods: {
        searchLabelManage() {
            _this.dynamicTags = [];
            _this.$post(
                "/order/getOrderModeDetails", {
                    order_mode_code: _this.search_data.order_mode_code,
                    city_code: JSON.parse(localStorage.getItem('login')).city.city_code
                }
                ).then(res => {
                    if (res.code == 200) {
                        _this.dynamicTags = res.data.label;
                    }
                }).catch((err) => {
                    _this.$message.error(err.msg);
            })
        },
        submitForm() {
            if (_this.dynamicTags.length == 0) {
                _this.$message({
                    message: '请添加标签',
                    type: 'warning'
                });
                return;
            }
            if (_this.dynamicTags.length > 2) {
                _this.$message({
                    message: '最多只能添加两个标签',
                    type: 'warning'
                });
                return;
            }
            _this.$post(
                "/order/editOrderModeLableSubmit", {
                    order_mode_code: _this.search_data.order_mode_code,
                    label: _this.dynamicTags
                }
                ).then(res => {
                    _this.$message.success(res.msg);
                    _this.closeDialog();

                }).catch((err) => {
                    _this.$message.error(err.msg);
            })
        },
        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },

        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.dynamicTags = [];
        },



    }
};
</script>

<style scoped>
.el-tag {
    height: 32px;
    line-height: 30px;
    margin-left: 10px;
}
    /* .el.el-tag + .el-tag {
    margin-left: 10px;
  } */
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .dialog-footer {
    margin-top: 20px;
    text-align: center;
  }
  /deep/.el-dialog__header {
  background: #05C0AB;
  padding: 20px;
  font-size: 16px;
  color: #fff;
  text-align: left;

}
/deep/.el-dialog__title {
  color: #fff;
}
.tip {
  color: #FF4B4B;
  padding: 10px 15px;
  font-size: 14px;
  margin-bottom: 20px;
  background: rgba(255, 75, 75, 0.1);
  border-radius: 5px;
}
</style>
